module.exports = __webpack_public_path__ + "img/guide.95a452e9.png";